import { useTranslation } from 'react-i18next';

import { IForgotPasswordForm } from 'authOld/types';
import { Field, Form } from 'coreOld/components';
import { InputType, Size } from 'coreOld/enums';
import { getRequiredLabel } from 'coreOld/utils';

import { forgotPasswordSchema } from './forgotPasswordSchema';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => (data: IForgotPasswordForm) => void;
  isSubmitted?: boolean;
  goBack: () => void;
}

const ForgotPasswordFormFormView = ({ isOpen, onClose, onSubmit, isSubmitted, goBack }: IProps) => {
  const { t } = useTranslation();

  return (
    <Form<IForgotPasswordForm>
      isOpen={isOpen}
      onClose={onClose}
      title={t('labelForgotPassword')}
      submitBtnLabel={isSubmitted ? undefined : t('buttonLabelSend')}
      defaultValues={{ email: '' }}
      onSubmit={onSubmit}
      schema={forgotPasswordSchema()}
      hasGoBack
      goBack={goBack}
    >
      {!isSubmitted && (
        <Field
          name="email"
          label={getRequiredLabel(t('labelEmailAddress'))}
          type={InputType.TEXTFIELD}
          inputProps={{
            size: Size.LG,
            autoFocus: true,
          }}
        />
      )}
    </Form>
  );
};

export default ForgotPasswordFormFormView;
